import { useSearchParams } from 'react-router'

import { VIEWINGS_VIEW_PARAM } from './useRentalPortalViewingsViewRegime.constants'
import { getViewingsViewRegime } from './useRentalPortalViewingsViewRegime.utils'

export function useRentalPortalViewingsViewRegime() {
  const [searchParams, setSearchParams] = useSearchParams()

  const listViewType = getViewingsViewRegime(searchParams)

  function handleChangeViewType(view) {
    setSearchParams(
      params => {
        params.set(VIEWINGS_VIEW_PARAM, view)

        return params
      },
      { replace: true }
    )
  }

  return { handleChangeViewType, listViewType }
}
